<template>
<div>
<ContentHeader :title="$store.state.languages.lang_phrases.yeni_marka_ozel_niteligi"  url="BrandCustomAttributes" :show_button="true"  icon="arrow-left" buttontype="danger" :label="$store.state.languages.lang_phrases.geri_don"></ContentHeader>


<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">
<form @submit.prevent="submitForm" class="mt-4">
<div class="grid">

<div class="col-12 md:col-6">
<InputTextValidate :data="fields[0]" :fieldindex="0" @emitValue="inputValueEmitted"></InputTextValidate>
</div>



<div class="col-12 md:col-6">
<InputSelectValidate :data="fields[1]" :fieldindex="1" @emitValue="inputValueEmitted"></InputSelectValidate>
</div>


<!-- if text or number-->
<div class="col-12 md:col-6" v-if="fields[1].value.id=='string'">
<InputTextValidate :data="fields[2]" :fieldindex="2" @emitValue="inputValueEmitted"></InputTextValidate>
</div>
<!-- if text or number-->

<!-- if text or number-->
<div class="col-12 md:col-6" v-if="fields[1].value.id=='number'">
<InputTextValidate :data="fields[3]" :fieldindex="3" @emitValue="inputValueEmitted"></InputTextValidate>
</div>
<!-- if text or number-->

<!-- if boolean-->
<div class="col-12 md:col-6" v-if="fields[1].value.id=='boolean' || fields[1].value.id=='select'">
<InputSelectValidate :data="fields[5]" :fieldindex="5" @emitValue="inputValueEmitted"></InputSelectValidate>
</div>
<!-- if boolean-->

<!-- if select-->
<div class="col-12 md:col-6" v-if="fields[1].value.id=='select'">
<InputChipsValidate :data="fields[4]" :fieldindex="4" @emitValue="inputValueEmitted"></InputChipsValidate>
</div>
<!-- if select-->








</div>



<div class="flex justify-content-end flex-wrap mt-3">
 <Button :label="$store.state.languages.lang_phrases.kaydet" class=" p-button-primary p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting" type="submit"></Button>
</div>



</form>
</template>

</div>
</template>
<script>
export default {

  name: 'CreateBrandCustomAttribute',

 data () {
    return {   
    	loading:true, 
    	item:null,	
    	fields:[
	      {
	        title:"İsim",
	        key:"name",
	        type:"text",
	        value:null,
	        min_length:2,
	        max_length:250,
	        is_required:true,
	        has_error:false,
	        error_message:null,
	        show:true,
	      },
	      {
	        title:"Tür",
	        key:"type",
	        type:"select",
	        value:[],
	        is_required:true,
	        has_error:false,
	        error_message:null,
	        show:true,
	        options:[
	        {
	          name:"Metin",
	          id:"string"
	        },
	        {
	          name:"Sayı",
	          id:"number"
	        },
	        {
	          name:"Açık/kapalı",
	          id:"boolean"
	        },
	        {
	          name:"Opsiyonlu",
	          id:"select"
	        },
          {
            name:"Çoklu Seçim Opsiyonlu",
            id:"multiselect"
          },
          {
            name:"Kategori",
            id:"categorised"
          },
          {
            name:"Kademeli Kategori",
            id:"cascadecategorised"
          },
	        ],
	      },
	      {
	        title:"Varsayılan Değer (Text)",
	        key:"default_text",
	        type:"text",
	        value:null,
	        min_length:0,
	        max_length:250,
	        is_required:false,
	        has_error:false,
	        error_message:null,
	        show:true,
	      },
	      {
	        title:"Varsayılan Değer (Sayı)",
	        key:"default_number",
	        type:"number",
	        value:null,
	        min_length:0,
	        max_length:250,
	        is_required:false,
	        has_error:false,
	        error_message:null,
	        show:true,
	      },
	      {
	        title:"Opsiyonlar",
	        key:"options",
	        type:"chips",
	        value:[],
	        min_length:0,
	        max_length:50000000,
	        is_required:false,
	        has_error:false,
	        error_message:null,
	        show:true,
	      },
	      {
	        title:"Varsayılan Durum",
	        key:"default_switch",
	        type:"select",
	        value:[],
	        is_required:false,
	        has_error:false,
	        error_message:null,
	        show:true,
	        options:[],
	      },

      ]
    }
  },
  computed:{
    preflang_id()
    {
      return this.$store.state.auth.user.preflang_id
    }
  },
  watch:
  {
    preflang_id()
    {
      setTimeout(()=>{
        this.fields[0].title = this.$store.state.languages.lang_phrases.isim
        this.fields[1].title = this.$store.state.languages.lang_phrases.tur
        this.fields[2].title = this.$store.state.languages.lang_phrases.varsayilan_deger_text
        this.fields[3].title = this.$store.state.languages.lang_phrases.varsayilan_deger_sayi
        this.fields[4].title = this.$store.state.languages.lang_phrases.opsiyonlar
        this.fields[5].title = this.$store.state.languages.lang_phrases.varsayilan_durum

        this.fields[1].options[0].name = this.$store.state.languages.lang_phrases.metin
        this.fields[1].options[1].name = this.$store.state.languages.lang_phrases.sayi
        this.fields[1].options[2].name = this.$store.state.languages.lang_phrases.acikkapali
        this.fields[1].options[3].name = this.$store.state.languages.lang_phrases.opsiyonlu
        this.fields[1].options[4].name = this.$store.state.languages.lang_phrases.kategori
        this.fields[1].options[5].name = this.$store.state.languages.lang_phrases.kademeli_kategori
      },500)
      
    }
  },
  mounted()
  {
  	
  		this.loading=false
  },
  methods:{
  	submitForm()
    {
    	console.log("the fields");
    	console.log(this.fields)
        let validated = this.validateForm(this.fields)
        if(!validated.has_error)
        {
          this.submit()
        }
        console.log(validated)
    },
    inputValueEmitted(data)
    { 
      this.fields[data.index].value = data.value 
      this.fields[data.index].has_error = false  
      //hide options
      
      //hide options

      //type changed
      if(data.index==1)  
      {
      	//show options
      	if(data.value.id=="select")
      	{
      		this.fields[4].show = true
      		//reset default options
      		this.fields[5].value = null
      		this.fields[5].options = []
      		//reset default options
      	}
      	//show options
      	//show boolean
      	else if(data.value.id=="boolean")
      	{
      		this.fields[4].show = false
      		//reset default options
      		this.fields[5].value = []
      		this.fields[5].options = [{name:"Açık",id:1},{name:"Kapalı",id:0}]
      		//reset default options
      	}
      	else
      	{
      		this.fields[4].show = false
      	}
      	//show boolean
      }
      //type changed

      //options updated
      if(data.index==4)
      {
      		//show options
      		this.fields[4].show = true
      		//show options
      		//reset default options
      		this.fields[5].value = null
      		this.fields[5].options = []
      		//reset default options

  			//push options to default
      		this.fields[5].options =  this.sanitizeArray(this.fields[4].value)
      		//push options to default
	      		

      }
      //options updated
    },
    submit()
    {         

      let formdata = this.createFormData(JSON.parse(JSON.stringify(this.fields)))
      console.log("formdata")
      console.log(formdata)
      formdata.append("brand_id",this.$route.params.id)    
      //formdata.append("data",JSON.stringify(this.fields))
      this.generalSubmission(formdata,"custom_attribute/store",this.afterSubmit)
    },
    afterSubmit(response)
    {
    	console.log(response.data)
    	this.$router.push({ name: 'BrandCustomAttribute', params: { attribute_id:response.data.id } })
        
       
      
    },
  }
};
</script>

<style lang="css" scoped>
</style>